// First multipart helper in the codebase. Builds a FormData from a File
// plus optional string fields; request() (api/client.ts) detects FormData
// and lets the browser set the multipart Content-Type + boundary.

export function buildMultipart(
  file: File,
  fields: Record<string, string> = {},
): FormData {
  const fd = new FormData();
  fd.append("file", file, file.name);
  for (const [k, v] of Object.entries(fields)) {
    fd.append(k, v);
  }
  return fd;
}
